import { supabase } from '../lib/supabase'
import { SIGN_IN_COPY, pickSignInLang, type SignInLang } from '../lib/signInCopy'
import { supportMailto } from '../lib/supportMail'
import { SupportText } from '../components/SupportText'
import logo from '../assets/conetec-logo.svg'

/**
 * Signed in, but nothing to show: a known person whose tenant membership is
 * not active (a leaver the nightly suspended, or a manual deactivation). David,
 * 8 Oct: tell them their access is not active and send them to OneConetec
 * support if they think that is wrong.
 *
 * Until 8 Oct this person fell through to an EMPTY hub: their identity and
 * person rows are self-readable (identity_read_self, person_read's self arm),
 * so loadMe resolved, and every other read is gated on an ACTIVE membership,
 * so nothing came back. App.tsx now routes `me.tenants.length === 0` here —
 * which is why lib/me.ts throws on a FAILED membership read rather than
 * treating it as "no memberships": a network blip must not tell an active
 * manager their access has gone.
 *
 * It reuses the sign-in card's look and words (SIGN_IN_COPY), because to the
 * person this is still the front door, not the hub.
 */
export function NoAccess({ locale, signedInAs }: { locale: string | null; signedInAs?: string | null }) {
  const nav = typeof navigator === 'undefined' ? [] : navigator.languages ?? [navigator.language]
  const lang: SignInLang = pickSignInLang([...(locale ? [locale] : []), ...nav])
  const t = SIGN_IN_COPY[lang]
  return (
    <main className="signin" lang={lang}>
      <div className="signin__card">
        <img className="signin__logo" src={logo} alt="Conetec" width={168} />
        <h1 className="signin__title">{t.inactiveTitle}</h1>
        <p className="signin__lede">
          <SupportText
            text={t.inactiveBody}
            href={supportMailto({
              reason: 'inactive',
              lang,
              method: signedInAs?.startsWith('+') ? 'phone' : 'email',
              tried: signedInAs,
            })}
          />
        </p>
        <div className="signin__footer">
          <button type="button" className="btn btn--link" onClick={() => supabase.auth.signOut()}>
            {t.signOut}
          </button>
        </div>
      </div>
      <p className="signin__legal">{t.legal}</p>
    </main>
  )
}
